// index.js

import React from 'react';
import ReactDOM from 'react-dom/client';

import { CartProvider,PromoCodeProvider } from './CartContext';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Calendar.css';
import "./styles.css";
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <BrowserRouter basename="/"> {/*basename="/blair-starter/"*/}
            <PromoCodeProvider>
                 <CartProvider>
                    <App></App>   
                </CartProvider>
            </PromoCodeProvider>    
        </BrowserRouter>
    </React.StrictMode>
);
reportWebVitals();
